import React from "react";
import PanelGroupController from "../../components/PanelGroupController";
import {fromJS} from "immutable";
import PropertiesList from "../../components/panels/PropertiesList";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {Query} from "react-apollo";
import {GET_ORDER} from "../../queries/sales";

const OrderInfoPanel = (props) => {

  function getType(data) {
    if (data.get("source") === "checkout" && data.get("subscription") === false) {
      return ["One-time Order", "string"];
    }
    if (data.get("source") === "checkout" && data.get("subscription") === true) {
      return ["New Subscription", "string"];
    }
    if (data.get("source") === "subscription") {
      return ["Subscription", "string"];
    }
    return ["", "string"];
  }

  let elements = null;
  if (!props.orderId || props.orderId === "") {
    elements = <p className="u-no-selection">Nothing selected</p>
  } else {
    let properties = fromJS([
      {prop: "orderId", label: "Id", type: "salesOrderId"},
      {prop: "accountId", label: "Account", type: "accountId"},
      {prop: "shippingOrderId", label: "Shipping", type: "shippingOrderId"},
      {prop: "subscriptionId", label: "Subscription", type: "subscriptionId"},
      {prop: "shopId", label: "Shop", type: "id"},
      {prop: "type", label: "Type", type: "string", fn: getType},
      {prop: "gift", label: "Gift", type: "boolean"},
      {prop: "promoCode", label: "Promo code", type: "id"},
      {prop: "currency", label: "Currency", type: "string"},
      {prop: "subtotalProducts", label: "Products", type: "string"},
      {prop: "subtotalTaxes", label: "Taxes", type: "string"},
      {prop: "discount", label: "Discount", type: "string"},
      {prop: "total", label: "Total", type: "string"},
      {prop: "billingStatus", label: "Billing Status", type: "string"},
      {prop: "status", label: "Status", type: "string"},
      {prop: "source", label: "Source", type: "string"},
      {prop: "paidAt", label: "Paid At", type: "utc"},
      {prop: "createdAt", label: "Created", type: "utc"},
    ])
    let variables = {orderId: props.orderId}
    elements = (
      <Query query={GET_ORDER} variables={variables} skip={props.orderId === ""} fetchPolicy="cache-and-network">
        {({ loading, error, data }) => {
          if (loading) return <Loading />
          if (error) return <GraphQLErrors error={error} />
          return (
            <PropertiesList properties={properties} data={fromJS(data.salesOrder)} />
          )
        }}
      </Query>
    )
  }

  return (
    <PanelGroupController title="Order Info" expanded={props.expanded}>
      {elements}
    </PanelGroupController>
  )

}

export default OrderInfoPanel;